/* eslint-disable */
import React from "react";
import { Link, useLocation } from "react-router-dom";
import DashIcon from "components/icons/DashIcon";

export function SidebarLinks({ routes, permissions, role }) {
  const location = useLocation();

  const isActive = (routePath) => location.pathname.includes(routePath);

  const isAdmin          = role === "admin";
  const hasNoPermissions = !permissions || Object.values(permissions).every((v) => v !== true);

  const shouldShow = (route) => {
    // Always skip secondary routes (SEARCH RESULTS, etc.) and auth routes
    if (route.secondary)           return false;
    if (route.layout !== "/admin") return false;

    // Admins see everything
    if (isAdmin) return true;

    // Non-admins with no permissions set: show only the hub
    if (hasNoPermissions) return route.name === "Command Hub";

    // Per-route permission gates
    if (route.name === "STAFF MANAGEMENT" && permissions?.can_access_staff          !== true) return false;
    if (route.name === "CRM"              && permissions?.can_access_crm            !== true) return false;
    if (route.name === "PROJECTS"         && permissions?.can_access_crm            !== true) return false;
    if (route.name === "ARTICLES CMS"     && permissions?.can_access_cms            !== true) return false;
    if (route.name === "SECURITY LOGS"    && permissions?.can_access_logs           !== true) return false;
    if (route.name === "REQUESTS"         && permissions?.can_access_leave_requests !== true) return false;

    // Hide personal profile from sidebar (accessible via navbar avatar)
    if (route.name === "PERSONAL PROFILE") return false;

    // Hide system login link from sidebar
    if (route.name === "SYSTEM LOGIN")     return false;

    return true;
  };

  return routes.map((route, index) => {
    if (!shouldShow(route)) return null;

    const active = isActive(route.path);

    return (
      <li key={index} className="list-none">
        <Link
          to={route.layout + "/" + route.path}
          className="block w-full"
          style={{ textDecoration: "none" }}
        >
          <div
            className={[
              "group relative flex items-center rounded-xl px-4 py-2.5",
              "transition-colors duration-150",
              active
                ? "bg-[#0055FF]/10"
                : "hover:bg-white/[0.05]",
            ].join(" ")}
          >
            {/* Icon */}
            <span
              className="flex-shrink-0"
              style={{ color: active ? "#0055FF" : "rgba(255,255,255,0.45)" }}
            >
              {route.icon ?? <DashIcon />}
            </span>

            {/* Label — ml-3 spacing, nowrap prevents two-line wrapping */}
            <span
              style={{
                fontFamily:    "'Inter', sans-serif",
                fontSize:      "12px",
                fontWeight:    active ? 600 : 400,
                letterSpacing: "0.07em",
                textTransform: "uppercase",
                whiteSpace:    "nowrap",
                color:         active ? "#0055FF" : "rgba(255,255,255,0.55)",
                lineHeight:    1,
                marginLeft:    "12px",
                transition:    "color 0.15s",
              }}
            >
              {route.name}
            </span>

            {/* Active indicator bar — right edge */}
            {active && (
              <div
                className="absolute right-0 top-1/2 -translate-y-1/2 rounded-l-full"
                style={{ width: "3px", height: "20px", background: "#0055FF" }}
              />
            )}
          </div>
        </Link>
      </li>
    );
  });
}

export default SidebarLinks;
